<script lang="ts">
    import { appState } from '../stores';
    import { fade } from 'svelte/transition';

    export let exitToArea:number = 0;
    export let zIndex:number = 5;

    function exitView(area:number) {
        $appState.view = exitToArea;
        $appState.modalOpen = false;
    }
</script>

<div
    on:click={() => exitView(0)}
    transition:fade={{duration: 500}}
    class="backdrop"
    style:z-Index={zIndex}
></div>

<style>
    .backdrop {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: color-mix(in srgb, var(--background), transparent 50%);
        backdrop-filter: blur(24px);
    }
</style>